<template>
    <Loader v-if="loading" />
    <div v-else class="content">
        <div class="flex">
            <h1>Goals</h1>
        </div>

        <Group class="margin-top" :class="this.errors.length && !is_edit_goal ? 'has-error': ''" title="Create Goal">
            <div v-if="errors.length && !is_edit_goal">
                <ul class="error">
                    <li v-for="error in errors">{{ error }}</li>
                </ul>
            </div>

            <label class="small-margin-left very-small-margin-right" for="goal_select">Type :</label>
            <select id="goal_select" v-model="form.type">
                <option v-for="option in goalTypes" v-bind:value="option.value">
                    {{ option.name }}
                </option>
            </select>

            <label class="small-margin-left very-small-margin-right" for="goal">Goal:</label>
            <input v-model.number="form.goal" type="text" id="goal" />

            <label class="small-margin-left very-small-margin-right" for="start_date">Start date:</label>
            <DateTimePicker id="start_date" v-model="form.start_date" type="date"></DateTimePicker>

            <label class="small-margin-left very-small-margin-right" for="end_date">End date:</label>
            <DateTimePicker id="end_date" v-model="form.end_date" type="date"></DateTimePicker>

            <button v-on:click.prevent="save" class="btn btn small-margin-left">Add</button>
        </Group>

        <div class="margin-top">
            <Group class="margin-top" title="Goal List">
                <Table class="margin-top" :columns="columns" :rows="getRows" :perpage="50"/>
                <div v-if="is_edit_goal"  style="border:1px solid #999;background:#fff;position:fixed;top:calc(50% - 100px);left:calc(50% - 500px);width:1000px;padding:30px;">
                    <div v-if="errors.length && is_edit_goal">
                        <ul class="error">
                            <li v-for="error in errors">{{ error }}</li>
                        </ul>
                    </div>
                    <div class="margin-bottom">
                        <h3 class="margin-bottom">Editing: {{ }}</h3>

                        <select v-model="edit_goal.type">
                            <option :selected="option.value === edit_goal.type" v-for="option in goalTypes" v-bind:value="option.value">
                                {{ option.name }}
                            </option>
                        </select>

                        <label class="small-margin-left very-small-margin-right" for="edit_goal">Goal:</label>
                        <input id="edit_goal" type="text" v-model.number="edit_goal.goal" />

                        <label class="small-margin-left very-small-margin-right" for="start_date">Start date:</label>
                        <DateTimePicker v-model="edit_goal.start_date" type="date"></DateTimePicker>

                        <label class="small-margin-left very-small-margin-right" for="end_date">End date:</label>
                        <DateTimePicker v-model="edit_goal.end_date" type="date"></DateTimePicker>
                    </div>
                    <button v-on:click="updateGoal();" class="small-margin-right">Update</button>
                    <button v-on:click="closeEditGoal();">Cancel</button>
                </div>
            </Group>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import moment from 'moment'

export default {
  data: () => ({
    loading: false,
    is_edit_goal: false,
    edit_goal: {},
    rows: [],
    errors: [],
    goalTypes: [
      { name: 'Stylings', value: 1 },
      { name: 'Basket size', value: 2 },
      { name: 'Hit rate', value: 3 },
      { name: 'Ratings', value: 4 },
      { name: 'Make happy', value: 5 },
      { name: 'Returns all', value: 6 }
    ],
    form: {
      type: '',
      goal: '',
      start_date: '',
      end_date: ''
    },

    columns: {
      id: {
        name: 'Id'
      },
      type: {
        name: 'Type'
      },
      goal: {
        name: 'Goal'
      },
      start_date: {
        name: 'Start Date',
        width: 15
      },
      end_date: {
        name: 'End Date',
        width: 15
      }
    }
  }),
  components: {
  },
  computed: {
    getRows () {
      const result = []
      for (var id in this.rows) {
        const goal = this.rows[id]

        result[id] = {
          rowId: id,
          id: goal.id,
          type: this.getGoalTypes(goal),
          goal: goal.goal,
          start_date: goal.start_date,
          end_date: goal.end_date,
          menu: [
            {
              name: 'Edit',
              onClick: (row) => this.editGoal(row.rowId)
            },
            {
              name: 'Delete',
              onClick: (row) => this.deleteGoal(row.rowId)
            }
          ]
        }
      }
      return result
    }
  },
  methods: {
    getGoalTypes (data) {
      return _.find(this.goalTypes, ['value', data.type]).name
    },
    save () {
      if (this.validate()) {
        this.form.start_date = moment(this.form.start_date).format('YYYY-MM-DD')
        this.form.end_date = moment(this.form.end_date).format('YYYY-MM-DD')

        Vue.$api.post('/stylist/create-type-goal', this.form, {
          loader: toggle => this.saving = toggle,
          callback: (data) => {
            this.resetForm()
            this.rows.push(data)
          }
        })
      }
    },

    resetForm () {
      for (const key in this.form) {
        this.form[key] = ''
      }
    },

    validate () {
      const form = this.is_edit_goal ? this.edit_goal : this.form
      this.errors = []
      if (!form.type) {
        this.errors.push('Type is required field')
      }
      if (!form.goal) {
        this.errors.push('Goal is required field')
      }
      if (typeof form.goal !== 'number') {
        this.errors.push('Goal field should be a number')
      }
      if (!form.start_date) {
        this.errors.push('Start Date is required field')
      }
      if (!form.end_date) {
        this.errors.push('End Date is required field')
      }

      return !this.errors.length
    },

    load () {
      Vue.$api.get('/stylist/type-goals', {}, {
        before: () => this.loading = true,
        always: () => this.loading = false,
        callback: (data) => this.rows = data
      })
    },

    editGoal (row) {
      this.edit_goal = { ...this.rows[row] }
      this.errors = {}
      this.edit_goal.start_date = moment(this.edit_goal.start_date)._d
      this.edit_goal.end_date = moment(this.edit_goal.end_date)._d
      this.edit_goal.goal = parseInt(this.edit_goal.goal)
      this.is_edit_goal = true
    },

    deleteGoal (row) {
      Vue.$api.delete('/stylist/delete-type-goal/' + this.rows[row].id, {}, {
        loader: toggle => this.saving = toggle,
        callback: () => {
          this.load()
        }
      })
    },

    updateGoal () {
      if (this.validate()) {
        this.edit_goal.start_date = moment(this.edit_goal.start_date).format('YYYY-MM-DD')
        this.edit_goal.end_date = moment(this.edit_goal.end_date).format('YYYY-MM-DD')

        Vue.$api.put('/stylist/update-type-goal', this.edit_goal, {
          loader: toggle => this.saving = toggle,
          callback: () => {
            this.is_edit_goal = false
            this.load()
          }
        })
      }
    },

    closeEditGoal () {
      this.is_edit_goal = false
      this.errors = {}
    }
  },
  created () {
    this.load()
  }
}
</script>
<style lang="less" scoped>
    .has-error {
        border-color: #FE0006;
    }

</style>
